import fetcher from 'api/fetcher';
import { push } from 'connected-react-router';
import { BALANCE_REPLENISHMENT_TRIGGER_PARAM } from 'utils/balance/balanceReplenishment';

import { sendMulticreationCampaignCreateFormSubmit } from 'components/MultiCreationAuction/api/sendMulticreationCampaignCreateFormSubmit';

import { setMultiCreationVacanciesAuctionInfo } from 'store/models/multiCreation';
import { AppThunkAction } from 'store/utils';

type FetchCreateAuctionBatch = (props: {
    setIsLoading: (loading: boolean) => void;
    callbackOnFail: (failedVacancyCount?: number) => void;
    callbackOnPartialFail: (createdCampaignCount: number, failedVacancyCount: number) => void;
    callbackOnSuccess: (createdCampaignCount: number) => void;
    dashboardRoute: string;
}) => AppThunkAction;

export const fetchCreateAuctionBatch: FetchCreateAuctionBatch = ({
    setIsLoading,
    callbackOnFail,
    callbackOnPartialFail,
    callbackOnSuccess,
    dashboardRoute,
}) => {
    return (dispatch, getState) => {
        const auctionsToCreate = getState().multiCreation.auctionsToCreate;
        const vacanciesAuctionInfo = getState().multiCreation.vacanciesAuctionInfo;
        const biddingStrategy = getState().multiCreation.biddingStrategy;
        setIsLoading(true);

        const body = {
            auctionsToCreate: Object.keys(auctionsToCreate).map((key) => {
                const vacancyId = Number(key);
                const { bid, budget, startAt, endAt } = auctionsToCreate[vacancyId];
                return {
                    vacancyId,
                    bid: Number(bid),
                    budget: Number(budget),
                    biddingStrategy,
                    startAt,
                    endAt,
                };
            }),
        };

        return fetcher
            .post<unknown, { createdCampaignIdByVacancyId: Record<number, number>; failedVacancyIds: number[] }>(
                `/api/v1/auction/batch`,
                body
            )
            .then(({ createdCampaignIdByVacancyId, failedVacancyIds }) => {
                const createdCampaignVacancyIds = Object.keys(createdCampaignIdByVacancyId);

                sendMulticreationCampaignCreateFormSubmit({
                    auctionsToCreate,
                    createdCampaignVacancyIds,
                    failedVacancyIds,
                    biddingStrategy,
                });

                setTimeout(() => {
                    if (createdCampaignVacancyIds.length === 0) {
                        callbackOnFail(failedVacancyIds.length);
                        return;
                    }

                    if (failedVacancyIds.length > 0) {
                        const filteredAuctionsToCreate = { ...auctionsToCreate };
                        const filteredVacanciesAuctionInfo = { ...vacanciesAuctionInfo };
                        createdCampaignVacancyIds.forEach((key) => {
                            const vacancyId = Number(key);
                            delete filteredAuctionsToCreate[vacancyId];
                            delete filteredVacanciesAuctionInfo[vacancyId];
                        });

                        failedVacancyIds.forEach((key) => {
                            const vacancyId = Number(key);
                            filteredAuctionsToCreate[vacancyId].isCreationFailed = true;
                        });

                        dispatch(
                            setMultiCreationVacanciesAuctionInfo({
                                auctionsToCreate: filteredAuctionsToCreate,
                                vacanciesAuctionInfo: filteredVacanciesAuctionInfo,
                            })
                        );
                        callbackOnPartialFail(createdCampaignVacancyIds.length, failedVacancyIds.length);
                    }

                    if (failedVacancyIds.length === 0) {
                        callbackOnSuccess(createdCampaignVacancyIds.length);
                        dispatch(push(`${dashboardRoute}?${BALANCE_REPLENISHMENT_TRIGGER_PARAM}`));
                    }
                }, 1000);
            })
            .catch((error) => {
                sendMulticreationCampaignCreateFormSubmit({
                    auctionsToCreate,
                    biddingStrategy,
                    errors: JSON.stringify(error),
                });
                callbackOnFail();
            });
    };
};
